import styled from "styled-components"
import { media } from "utils/utils"

export const ContentWrapper = styled.div`
  text-align: left;
  ${props => (props.margin ? `margin: ${props.margin};` : null)}
  ${props => (props.width ? `width: ${props.width};` : null)}
`

export const FooterWrapper = styled.div`
  text-align: left;
  margin-top: 55px;
`
export const FooterWrapperCentered = styled.div`
  text-align: center;
  margin-top: 55px;
`

export const CloseButton = styled.div`
  width: 28px;
  height: 28px;
  color: ${props => props.theme.colors.textPrimary};
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  transition: all ease-in-out 0.2s;
  z-index: 999;

  &:hover {
    color: ${props => props.theme.colors.textSecondary};
  }

  :focus {
    outline: 2px solid #015ecc !important;
  }

  ${media.md`
    width: 20px;
    height: 20px;
  `};
`

export const SelectRow = styled.div`
  margin-top: 15px;
`

export const FormRow = styled.div`
  display: ${props => (props.flex ? "flex" : "block")};
  ${props => (props.flex ? "align-items: center;" : null)};
  ${props =>
    props.marginTop ? `margin-top: ${props.marginTop};` : "margin-top: 40px;"}
  &:first-of-type {
    margin-top: 9px;
  }
`

export const FormRowFlex = styled.div`
  margin-top: 40px;
  display: flex;

  &:first-of-type {
    margin-top: 9px;
  }
`

export const SelectWrapper = styled.div`
  width: 216px;
  margin-right: 24px;
`

export const Tag = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 5px 10px;
  background: #f7f7f7;
  position: relative;
  display: inline-block;
  margin-right: 10px;
`

export const Delete = styled.div`
  width: 15px;
  height: 16px;
  cursor: pointer;
  display: inline-block;
  margin: -1px 0 0 5px;
  &:hover {
    cursor: pointer;
  }
`
export const OptionalHeader = styled.text`
  font-size: 14px;
  font-weight: normal;
  color: ${props => props.theme.colors.textSecondary};
`
